import React, { Component } from 'react'
import { observable, action, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import classNames from 'classnames'

import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'

import { LESSON_STATUSES_PUBLISH_STATES } from 'constants/courses.constants'

import { getSearchParams } from 'utils/queryString.utils'

import IconBurgerMenu from 'ui/icons/IconBurgerMenu'
import ConfirmationModal from 'ui/confirmation-modal/ConfirmationModal'
import { EloButton } from '@elo-kit/components/elo-button/EloButton'

@observer
class DefaultPageNavigation extends Component {
  @observable confirmationModal = false

  @action toggleConfirmationModal = () => (this.confirmationModal = !this.confirmationModal)

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  render() {
    const { contentPageStore, courseViewsStore, currenciesStore, historyGoBack, pathname } = this.props
    const {
      activeLesson: { active },
      activeLesson = {},
      activeLessonStatus = {},
      courseSession,
      mobileMenuActive,
      toggleMobileMenu,
      handleReset,
      setPrevLesson,
      setNextLesson,
      finishLesson,
      seller: { username, avatarUrl } = {},
      product,
      viewConfig: {
        isShop,
        isPayerCabinet,
        showPrevBtn,
        showNextBtn,
        showFinishBtn,
        lessonIsFinished,
        shouldCompleteQuiz,
      },
    } = courseViewsStore
    const { allVideoCodesValid, isCourseRefreshAppActive } = contentPageStore

    const { allowLessonReset, lessonSettings = {} } = activeLesson
    const { pricingPlans, slug, displayPrice, displayCurrencyId } = product || {}

    const courseRefreshAppActive = isCourseRefreshAppActive && isCourseRefreshAppActive(courseSession.seller?.id)
    const isNavigationButtonDisabled = shouldCompleteQuiz && lessonIsFinished

    const navClasses = classNames('navbar fixed-top navbar-expand-lg course-top-nav', { 'payment-continue': isShop })

    const { is_preview: isPreview } = getSearchParams()
    const checkoutHref = `/s/${username}/${slug}/payment${isPreview ? '&is_preview=true' : ''}`
    const showBackButton = !pathname.includes('course-preview')

    const buyButton = (
      <a id='continue' className='btn btn-warning btn-lg continue' href={checkoutHref}>
        {displayPrice && (
          <div className='sum' translate='no'>
            {currenciesStore.convertToPrice(displayPrice, displayCurrencyId)}
          </div>
        )}

        {!((pricingPlans || [])[0] || {}).useNetPrice && <div className='addition'>(inkl. USt)</div>}

        <div className='continue-text with-left-border'>
          <div className='d-none d-sm-block'>{I18n.t('react.shared.button.buy_and_continue')}</div>
          <div className='d-block d-sm-none'>{I18n.t('react.shared.button.buy')}</div>
        </div>

        <i className='fas fa-arrow-right' />
      </a>
    )

    const prevBtn = (
      <div className='nav-item course-top-nav__previous-btn'>
        <button
          type='button'
          className='elo-btn outline-grey elo_button'
          onClick={setPrevLesson}
          disabled={isNavigationButtonDisabled}
        >
          <i className='fas fa-chevron-left' />
          <span>{I18n.t('react.shared.lessons.prevLesson')}</span>
        </button>
      </div>
    )

    const nextBtn = (
      <div className='nav-item course-top-nav__next-btn'>
        <button type='button' className='elo-btn orange' onClick={setNextLesson} disabled={isNavigationButtonDisabled}>
          <span>{I18n.t('react.shared.lessons.nextLesson')}</span>
          <i className='fas fa-chevron-right' />
        </button>
      </div>
    )

    const finishBtn = (
      <div className='nav-item course-top-nav__finish-btn'>
        <button
          type='button'
          className='elo-btn orange elo_button'
          onClick={finishLesson}
          disabled={!allVideoCodesValid}
        >
          <span>{lessonSettings.finishButtonText || I18n.t('react.shared.lesson.finishLesson')}</span>
          <i className='fas fa-check' />
        </button>
      </div>
    )

    const resetLessonAvailable =
      courseRefreshAppActive &&
      allowLessonReset &&
      activeLessonStatus.publishState === LESSON_STATUSES_PUBLISH_STATES.finished

    return (
      <nav className={navClasses}>
        <div className='nav-inner'>
          <div className='nav-inner__left-block'>
            <div id='course-burger-menu' onClick={toggleMobileMenu}>
              {mobileMenuActive ? <i className='fas fa-times' /> : <IconBurgerMenu />}
            </div>

            {!isShop && (
              <div className='navbar-nav back-link'>
                {showBackButton && (
                  <div className='nav-item'>
                    <EloButton
                      className='back-btn'
                      onClick={historyGoBack}
                      disabled={isNavigationButtonDisabled}
                      outlined
                      grey
                    >
                      {I18n.t('shared.common.back')}
                    </EloButton>
                  </div>
                )}
                {resetLessonAvailable && (
                  <div className='nav-item'>
                    <EloButton
                      className='back-btn reset-lesson-btn'
                      onClick={this.toggleConfirmationModal}
                      outlined
                      grey
                    >
                      <i className='fas fa-undo-alt' />
                      {I18n.t('react.shared.button.reset')}
                    </EloButton>
                  </div>
                )}
              </div>
            )}

            {(isPayerCabinet || isShop) && (
              <div className='seller-data'>
                <div className='seller-data__avatar' style={{ backgroundImage: getBackgroundImageCss(avatarUrl) }} />
                <div className='seller-data__name'>{username}</div>
              </div>
            )}
          </div>

          {isShop ? (
            buyButton
          ) : (
            <div className='navbar-nav'>
              {showPrevBtn && prevBtn}
              {active && showFinishBtn && finishBtn}
              {active && !showFinishBtn && showNextBtn && nextBtn}
            </div>
          )}
        </div>

        <ConfirmationModal
          isOpen={this.confirmationModal}
          submit={() => handleReset(this.props.cmpProps)}
          submitButtonChild={I18n.t('react.shared.button.reset_lesson')}
          title={I18n.t('react.shared.confirm_lesson_reset')}
          toggle={this.toggleConfirmationModal}
        />
      </nav>
    )
  }
}

DefaultPageNavigation.displayName = 'DefaultPageNavigation'

export default DefaultPageNavigation
